<portal-configuration-menu> </portal-configuration-menu>
<hr>

<div class="alert alert-warning" role="alert" *ngIf="_portalConfigurationService.alert">
  {{ _portalConfigurationService.alert | translate }}
</div>

<loading-component *ngIf="_portalConfigurationService.loading"></loading-component>

<div class="container" *ngIf="!_portalConfigurationService.loading">
  <div class="row">
    <div class="col">
    </div>
    <div class="float-right">
      <button class="btn btn-secondary-color btn-sm" data-toggle="modal" data-target="#AddFaqModal">
        {{ 'ADD_FAQ' | translate }}</button>
    </div>
  </div>
</div>

<fieldset class="fieldsetborder margin-bottom-50"
  *ngFor="let language of _resourceService.languages">
  <legend class="main-color">&nbsp;{{ 'QUESTIONS_IN' | translate}} {{ language.name }} &nbsp;
  </legend>

  <div *ngFor="let faq of _portalConfigurationService.faqs | filterFaqsByLanguage:language.id">
    <div class="card sm-12">
      <div class="card-header btn-main-color">
        {{ faq.question }}
      </div>

      <div class="card-body">

        <div class="row">
          {{ faq.answer }}
        </div>
        <div class="row  hide-on-print">
          <small class="text-muted">{{ 'OPTIONS' | translate}}</small>
        </div>
        <div class="row  hide-on-print">
          <button type="button" class="btn background-secondary-color" data-toggle="modal"
            data-target="#EditedFaqModal" (click)="editFaq(faq)">
            {{ 'EDIT' | translate}}
          </button>
          <button type="button" class="btn btn-danger" data-toggle="modal"
            data-target="#DeleteFaqModal" (click)="selectFaq(faq)">
            {{ 'DELETE' | translate}}
          </button>
        </div>
      </div>
    </div>
    <br />
  </div>
</fieldset>

<!-- Modals -->

<!-- The delete faq Modal -->
<div class="modal fade" id="DeleteFaqModal">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-body">
        <div class="modal-header">
          <h4 class="modal-title">{{ 'ARE_YOU_SURE' | translate}}</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <p>
            {{ 'DO_YOU_WANT_DELETE_FAQ' | translate}}
            {{selectedFaq?.question}}
          </p>
          <div class="row">
            <div class="form-group col-md-6">
              <button type="submit" class="btn btn-danger btn-block" (click)="deleteFaq()"
                data-dismiss="modal">
                {{ 'YES' | translate}}
              </button>
            </div>
            <div class="col-md-6">
              <button type="submit" class="btn btn-secondary btn-block" data-dismiss="modal">
                {{ 'NO' | translate}}
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>


<!-- The edit faq Modal -->
<div class="modal fade" id="EditedFaqModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-body">
        <div class="modal-header">
          <h4 class="modal-title">{{ 'EDIT_FAQ' | translate}}</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <!-- Modal body -->
        <div class="modal-body" *ngIf="editedFaq">
          <div class="form-group">
            <label for="language">{{ 'LANGUAGE' | translate}} *</label>
            <div class="input-group col-12">
              <select class="form-control" [(ngModel)]="editedFaq.language" name="language"
                placeholder="Select language">
                <option *ngFor="let language of _resourceService.languages" [value]="language.id"
                  [selected]="language.id == selectedFaq?.language">
                  {{ language.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label for="question">{{ 'QUESTION' | translate}}</label>
              <textarea type="text" class="form-control" value="{{selectedFaq?.question}}"
                [(ngModel)]="editedFaq.question" rows="3"></textarea>
            </div>
            <div class="form-group col-md-12">
              <label for="answer">{{ 'ANSWER' | translate}}</label>
              <textarea type="text" class="form-control" value="{{selectedFaq?.answer}}"
                [(ngModel)]="editedFaq.answer" rows="3"></textarea>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-6">
              <button type="submit" class="btn btn-danger btn-block" (click)="updateFaq()">
                {{ 'EDIT' | translate}}
              </button>
            </div>
            <div class="col-md-6">
              <button type="submit" class="btn btn-secondary btn-block" data-dismiss="modal"
                (click)="cancelEditFaq()">
                {{ 'CANCEL' | translate}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
&nbsp;


<!-- The Add FAQ Modal -->
<div class="modal fade" id="AddFaqModal">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">{{ 'ADD_FAQ' | translate}} </h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <div class="alert alert-danger" role="alert" *ngIf=" _resourceService.alert">
          {{ _resourceService.alert | translate }}
        </div>



        <div class="form-group">
          <label for="language">{{ 'LANGUAGE' | translate}}</label>
          <div class="input-group col-12">
            <select class="form-control" id="language" placeholder="Select language"
              [(ngModel)]="newFaq.language">
              <option *ngFor="let language of _resourceService.languages" [value]="language.id">
                {{ language.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12">
            <label for="question">{{ 'QUESTION' | translate}}</label>
            <textarea type="text" class="form-control" id="question" placeholder="Question"
              [(ngModel)]="newFaq.question" rows="3"></textarea>
          </div>
          <div class="form-group col-md-12">
            <label for="answer">{{ 'ANSWER' | translate}}</label>
            <textarea type="text" class="form-control" id="answer" placeholder="Answer"
              [(ngModel)]="newFaq.answer" rows="3"></textarea>
          </div>
        </div>




        <div class="col text-center">
          <button type="submit" class="btn btn-main-color" (click)="addFaq()">
            {{ 'ADD_FAQ' | translate}}
          </button>
        </div>
      </div>

    </div>
  </div>
</div>